// Popup Window Builder

<template>
	<div class="bld-pop-win-main">

		<div class="title wi8_font">Pop Window Builder</div>

		<button class="btn" @click="goPopupWin">Popup Win</button><br/>
		<div class="v-spacer"></div>
		<button class="btn" @click="goPopupHelp">Popup Help</button><br/>
		<div class="v-spacer"></div>
		<button class="btn" @click="goPopupWinEdit">Popup Win Edit</button><br/>
		<div class="v-spacer"></div>
		<button class="btn" @click="goPopupCatPick">Popup Cat Pick</button><br/>
		<div class="v-spacer"></div>
		<button class="btn" @click="goPopupDoor">Popup Door</button><br/>
		<div class="v-spacer"></div>
		
		<button class="btn" @click="goPopupIn">Popup Input</button> &nbsp;
		<div id="inp-name" @click="popupInput" v-html="convertLFs(rec.name)"></div>
		<div class="v-spacer"></div>
		
		<button class="btn" @click="goPopupIn">Popup Input</button> &nbsp;
		<div id="inp-story" @click="popupInput" v-html="convertLFs(rec.story)"></div>
		<div class="v-spacer"></div>

		<button class="btn" @click="goPopOff">Pop Off</button><br/>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { eventBus } from '@/main';

export default {
	data() {
		return {
			myValue:"",
			rec: {
				name: "Fred Flintstone",
				story: "This is his story."
			},
			popElements: {
				"inp-name": {
					colName: "name",
					popType: "input",
					label: "Enter Name",
					// multiLine: true,
					width: 260,
					maxLen: 100,
				},
				"inp-story": {
					colName: "story",
					popType: "input",
					label: "Enter Story",
					multiLine: true,
					maxLen: 300,
				},
			},
		};
	},
	methods: {
		popupInput(evt) {
			m("popup input", evt.target.id);
			let eleId = evt.target.id;
			let val = document.getElementById(eleId).innerText;
			let colName = this.popElements[eleId].colName;

			let payload = {
				eleId: eleId,
				colName: colName,
				popType: this.popElements[eleId].popType,
				popTitle: this.popElements[eleId].label,
				defaultVal: this.rec[colName],
				maxLen: this.popElements[eleId].maxLen || 50,
				width: this.popElements[eleId].width || 120,
				multiLine: (this.popElements[eleId].multiLine===true),
			};
			m("payload", payload);
			eventBus.$emit("popup", payload);			
		},
		handleUpdateVal(payload) {
			m("form caught handle update", payload);
			let el = document.getElementById(payload.eleId);
			let val = payload.val;
			el.innerText = val;

			m("new val", val.length, val);

			this.rec[payload.colName] = val;			
			m("rec is now", this.rec);

		},
		convertLFs(str1="") {
			m("convert LFs", str1);
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
		handleUpdateValOLD(data) {
			m("build caught handle update", data);
			const el = this.$refs[data.fieldId];
			if (el != undefined) el.value = data.val;
		},
		goPopupWinEdit() {
			m("go popup win edit");
			let payload = {
				popType: "win",
				popTitle: "Admin: Edit Article",
				compName: "AdmEdit",
			};
			eventBus.$emit("popup", payload);			
		},
		goPopupWin() {
			m("go popup win");
			let payload = {
				popType: "win",
				popTitle: "Have a great day! Please Drive Safely and Buckle Up!!",
				compName: "ArtDetail",
			};
			eventBus.$emit("popup", payload);			
		},
		goPopupHelp() {
			m("go popup help");
			let payload = {
				popType: "win",
				popTitle: "Help Me!",
				compName: "HelpMainImg",
			};
			eventBus.$emit("popup", payload);			
		},
		goPopupCatPick() {
			m("go popup cat pick");
			let payload = {
				popType: "win",
				popTitle: "Choose Category",
				compName: "CatPick",
				compData: {
					step: "current",
				},
			};
			eventBus.$emit("popup", payload);			
		},
		goPopupDoor() {
			m("go popup door");
			let payload = {
				popType: "door",
				popTitle: "Choose Category",
				popText: "This is the door text.",
				compName: "CatPick",
				compData: {
					step: "current",
				},
			};
			eventBus.$emit("popup", payload);			
		},
		goPopupIn() {
			m("go popup input");
			let payload = {
				popType: "input",
				popTitle: "Enter user name",
				defaultVal: "Maxwell Smart",
				maxLen: 30,
				width: 120,
				formId: "userDataForm",
				fieldId: "userName",
			};
			eventBus.$emit("popup", payload);			
		},
		goPopupText() {
			m("go popup text");
			let payload = {
				popType: "input",
				popTitle: "Enter your lengthy story",
				defaultVal: "My story is a sad but not uncommon one...",
				multiLine: true,
				maxLength: 1000,
				formId: "userDataForm",
				fieldId: "storyTxt",
			};
			eventBus.$emit("popup", payload);			
		},

		goPopOff() {
			m("pop off");
			eventBus.$emit("popoff");			
		},
	},
	
	created() {
		m("build created");
		eventBus.$on('update-value', this.handleUpdateVal);
	},
	beforeDestroy() {
		eventBus.$off('update-value', this.handleUpdateVal);
	},
	
}
</script>

<style scoped>
.bld-pop-win-main {
	height: 100%;
	background-color: #FCFCEE;
	padding: 5px;
	border: solid 0px #009;
}

.title {
	color: #936;
}

.btn {
	width: 120px;
	vertical-align: top;
}

#inp-name {
	display: inline-block;
	width: 250px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	overflow-x: none;
	overflow-y: auto;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

#inp-story {
	display: inline-block;
	width: 250px;
	height: 100px;
	overflow: hidden;
	vertical-align: top;
	overflow-x: none;
	overflow-y: auto;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

.v-spacer {
	width: 10px;
	height: 10px;
	overflow: hidden;
	border: solid 0px #69C;
}



</style>
